var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationTriangleFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6513 3.31302C13.5206 1.20381 10.4966 1.20273 9.36432 3.31111L1.70102 17.581C0.627725 19.5796 2.07546 22.0004 4.34402 22.0004H19.6574C21.925 22.0004 23.3728 19.5814 22.3014 17.5829L14.6513 3.31302ZM12.999 9C12.999 8.44772 12.5513 8 11.999 8C11.4467 8 10.999 8.44772 10.999 9V13C10.999 13.5523 11.4467 14 11.999 14C12.5513 14 12.999 13.5523 12.999 13V9ZM11.999 16C11.4467 16 10.999 16.4477 10.999 17C10.999 17.5523 11.4467 18 11.999 18H12.009C12.5613 18 13.009 17.5523 13.009 17C13.009 16.4477 12.5613 16 12.009 16H11.999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangleFilled);
export default __webpack_public_path__ + "static/media/exclamation-triangle-filled.243e48c033933818b13121610af7bccf.svg";
export { ForwardRef as ReactComponent };